import React from 'react';
import PropTypes from 'prop-types';
import styles from './DataTable.module.scss';

/* ────────────────────────────────────────────────────────────
 * DataTable — page-level table convention.
 *
 *   <PagePanel>
 *     <DataTable>
 *       <thead>
 *         <tr><th>Date</th>...</tr>
 *       </thead>
 *       <tbody>
 *         <tr><td>...</td></tr>
 *       </tbody>
 *     </DataTable>
 *   </PagePanel>
 *
 * Owns: scroll wrapper (vertical + horizontal), thin scrollbar,
 * sticky uppercase tinted thead, cell padding, hover row state,
 * border treatment. Consumers only provide <thead>/<tbody> rows.
 *
 * Use the lower-level <Table> primitive instead when rendering a
 * nested or non-page-level table (e.g. a breakdown inside an
 * expandable row).
 * ──────────────────────────────────────────────────────────── */

const DataTable = ({ stickyHeader, hoverable, children, className }) => {
  const wrapClass = [styles.wrap, className || ''].filter(Boolean).join(' ');
  const tableClass = [
    styles.table,
    stickyHeader ? styles.sticky : '',
    hoverable ? styles.hoverable : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={wrapClass}>
      <table className={tableClass}>{children}</table>
    </div>
  );
};

DataTable.propTypes = {
  stickyHeader: PropTypes.bool,
  hoverable: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

DataTable.defaultProps = {
  stickyHeader: true,
  hoverable: true,
  className: '',
};

export default DataTable;
